export default __webpack_public_path__ + "static/media/headphone.d3e5705f.svg";